import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

import { ModalContentContainer, TextField } from '@/components';
import { EpisodeShareSocialLinks } from '@/constants';
import { SnackbarUtils } from '@/utils';

export const EpisodeSocialLinks = ({
  episodeDeepLink,
  episodeId,
  onClose,
}: {
  episodeDeepLink: string;
  episodeId: string;
  onClose: () => void;
}) => {
  const socialLinks = useMemo(
    () =>
      EpisodeShareSocialLinks.map(link => {
        const params = [...link.params, `utm_content=${episodeId}`].join('&');
        return {
          platform: link.platform,
          link: `${episodeDeepLink}?${params}`,
        };
      }),
    [episodeDeepLink, episodeId],
  );

  return (
    <Box sx={{ width: { xs: 'auto', md: 600 } }}>
      <ModalContentContainer onModalClose={onClose} stretch>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
          }}>
          <Typography variant="h2">Episode Social Links</Typography>
          {socialLinks.map(({ link, platform }) => (
            <Box
              sx={{ display: 'flex', gap: 1, alignItems: 'center' }}
              key={platform}>
              <Typography variant="body2SemiBold" sx={{ width: 100 }}>
                {platform}:
              </Typography>
              <TextField
                fullWidth
                value={link}
                sx={{
                  flex: 1,
                  '& .MuiOutlinedInput-input': {
                    cursor: 'pointer',
                  },
                }}
                onClick={() => {
                  navigator.clipboard.writeText(link);
                  SnackbarUtils.success('Link copied to clipboard');
                }}
                slotProps={{
                  input: {
                    readOnly: true,
                  },
                }}
              />
            </Box>
          ))}
        </Box>
      </ModalContentContainer>
    </Box>
  );
};
